import React, { useId } from "react";
import classnames from "classnames";
import styles from "./MobileInput.module.scss";

export interface MobileInputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "value" | "size"> {
    /** Подпись над полем: видимая, не только placeholder */
    label: string;
    value: string;
    onChange: (value: string) => void;
    /** Текст ошибки под полем; задан — поле подсвечено */
    error?: string;
    /** Пояснение под полем, когда ошибки нет */
    hint?: string;
    /** Ref на сам `input` */
    inputRef?: React.Ref<HTMLInputElement>;
}

/**
 * Поле ввода для телефона: подпись, высота 48 px, шрифт 16 px (меньше — iPhone увеличивает
 * страницу при фокусе), ошибка под полем. Без Blueprint: работает с обычным `<input>`,
 * `inputMode`, `autoComplete` и остальными атрибутами.
 */
export const MobileInput = ({
    label,
    value,
    onChange,
    error,
    hint,
    inputRef,
    className,
    id,
    ...rest
}: MobileInputProps) => {
    const generated = useId();
    const inputId = id || generated;
    const describedBy = error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined;

    return (
        <div className={classnames(styles.field, className)}>
            <label className={styles.label} htmlFor={inputId}>
                {label}
            </label>
            <input
                {...rest}
                id={inputId}
                ref={inputRef}
                className={classnames(styles.input, { [styles.invalid]: !!error })}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                aria-invalid={error ? true : undefined}
                aria-describedby={describedBy}
            />
            {error ? (
                <span id={`${inputId}-error`} className={styles.error} role="alert">
                    {error}
                </span>
            ) : (
                hint && (
                    <span id={`${inputId}-hint`} className={styles.hint}>
                        {hint}
                    </span>
                )
            )}
        </div>
    );
};
